<template>
  <div class="d-flex align-center justify-center" style="height: 100vh">
    <v-sheet width="400" class="mx-auto pa-6 rounded-lg elevation-4">
      <v-form fast-fail @submit.prevent="submit">
        <v-text-field
          v-model="username"
          label="User Name"
          variant="underlined"
          density="comfortable"
          prepend-inner-icon="mdi-account"
        />

        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          variant="underlined"
          density="comfortable"
          prepend-inner-icon="mdi-lock"
        />

        <v-btn
          type="submit"
          color="primary"
          variant="flat"
          block
          class="mt-4"
        >
          Sign in
        </v-btn>
      </v-form>
    </v-sheet>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import LoginAPI from '@/api/User.js'

const username = ref('')
const password = ref('')
const router = useRouter()
const { locale } = useI18n({ useScope: 'global' })

onMounted(() => {
  localStorage['auth_dreamdeal_website'] = 0
})

function submit () {
  LoginAPI.logout(null)
    .then(() => {
      login()
    })
    .catch(() => {
      login()
    })
}

function login () {
  const pwd_enc = $encryptValue(password.value) // mantém a função global que já usas

  const login_data = {
    username: username.value,
    password: pwd_enc,
    place: 'client_website',
    client_id: process.env.VUE_APP_CLIENT_ID
  }

  LoginAPI.login(login_data)
    .then(() => {
      localStorage['auth_dreamdeal_website'] = 1
      router.push('/' + (locale.value || 'pt') + '/backend')
    })
    .catch(err => {
      console.error('Login inválido: ' + err)
    })
}
</script>
